import { QUESTION_TYPES } from "../../../constants";

function isWrittenQuestion(q: unknown): boolean {
  return (
    String((q as { questionType?: string })?.questionType || "").toLowerCase() ===
    QUESTION_TYPES.WRITING
  );
}

/** Normalized key for matching template questions to feedback rows (same idea as `incbotFeedbackData`). */
export function normalizeInterviewQuestionKey(text: string): string {
  return (text || "").replace(/\s+/g, "").replace(/\r?\n|\r/g, "");
}

/**
 * True if the interview payload defines a written question outside `feedback`:
 * checks both `interview.question.questions` (assessment template) and `interview.questions` (instance list).
 */
export function interviewPayloadHasWritten(interview: unknown): boolean {
  if (!interview || typeof interview !== "object") return false;
  const inv = interview as {
    question?: { questions?: unknown[] };
    questions?: unknown[];
  };
  return (
    (inv.question?.questions ?? []).some(isWrittenQuestion) ||
    (inv.questions ?? []).some(isWrittenQuestion)
  );
}

/** Deduped written prompts from the interview (template + instance lists). */
export function collectInterviewWrittenTemplates(interview: unknown): unknown[] {
  if (!interview || typeof interview !== "object") return [];
  const inv = interview as {
    question?: { questions?: unknown[] };
    questions?: unknown[];
  };
  const out: unknown[] = [];
  const seen = new Set<string>();
  for (const q of [...(inv.question?.questions ?? []), ...(inv.questions ?? [])]) {
    if (!isWrittenQuestion(q)) continue;
    const tq = q as { translate?: { question?: string }; question?: string };
    const text = (tq?.translate?.question || tq?.question || "").trim();
    const key = normalizeInterviewQuestionKey(text);
    if (!key || seen.has(key)) continue;
    seen.add(key);
    out.push(q);
  }
  return out;
}
